import { render, staticRenderFns } from "./MediaGalleryItem.vue?vue&type=template&id=170fcd21&scoped=true&"
import script from "./MediaGalleryItem.vue?vue&type=script&lang=ts&"
export * from "./MediaGalleryItem.vue?vue&type=script&lang=ts&"
import style0 from "./MediaGalleryItem.vue?vue&type=style&index=0&id=170fcd21&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "170fcd21",
  null
  
)

export default component.exports